import { useQuery } from "react-query";

import { getPaymentResult, PaymentProduct, PaymentStatus } from "api/payment";

export default function usePaymentResult(saleTID: string) {
  return useQuery<{
    shopName: string;
    bizNumber: string;
    amount: number;
    approvalDate: string;
    approvalNumber: string;
    productList: Array<PaymentProduct>
    checkDate: string | null;
    status: PaymentStatus;
  }, Error>(['paymentResult', saleTID], async (params) => (await getPaymentResult({ saleTID }))
  );
}